import { render, staticRenderFns } from "./BidsList.vue?vue&type=template&id=408cb58b&"
import script from "./BidsList.vue?vue&type=script&lang=js&"
export * from "./BidsList.vue?vue&type=script&lang=js&"
import style0 from "./BidsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports